export default __webpack_public_path__ + "static/media/Order.070aa4c3.svg";